// Логика попапа авторизации. Один <form> на два шага:
//   шаг 'email' — отправляем email, бэк шлёт одноразовый код → раскрываем поле кода;
//   шаг 'code'  — отправляем код, бэк логинит (новому юзеру создаёт профиль сам).
// После входа НЕ перезагружаем страницу: закрываем попап и шлём CustomEvent
// 'auth:success' — на него реагируют шапка (показать e-mail) и гейт оформления
// (переотправить заказ). Так не нужен sessionStorage и не теряется состояние формы.
// Открытие/закрытие попапа — общий Popup.js (data-popup-*); здесь только сама форма.

const AUTH_MID = 2; // mod_auth в таблице modules

export function initAuthPopup() {
	const form = document.querySelector('[data-auth-form]');
	if (!form) return;

	const emailInput = form.querySelector('#auth-email');
	const codeItem = form.querySelector('[data-auth-code]');
	const codeInput = form.querySelector('#auth-code');
	const submitText = form.querySelector('[data-auth-submit-text]');
	const mistakes = form.querySelector('[data-auth-mistakes]');
	const loader = form.querySelector('[data-auth-loader]');
	const consent = form.querySelector('#auth-agree-pd');
	const resendBtn = form.querySelector('[data-auth-resend]');

	form.dataset.step = 'email';
	let busy = false;

	function setBusy(on) {
		busy = on;
		if (loader) loader.classList.toggle('active', on);
	}

	function showError(msg) {
		if (!mistakes) return;
		mistakes.textContent = msg || '';
		mistakes.style.display = msg ? 'block' : 'none';
	}

	function toCodeStep() {
		form.dataset.step = 'code';
		codeItem.hidden = false;
		if (submitText) submitText.textContent = 'Войти';
		codeInput.focus();
	}

	// Вернуть форму к первому шагу (после успешного входа — попап не релоадит страницу).
	function resetForm() {
		form.dataset.step = 'email';
		codeItem.hidden = true;
		codeInput.value = '';
		if (consent) consent.checked = false;
		if (submitText) submitText.textContent = 'Получить код';
		showError('');
	}

	async function post(action, payload) {
		const data = new FormData();
		data.set('action', action);
		Object.entries(payload).forEach(([k, v]) => data.set(k, v));
		const res = await fetch(`/ajax.php?mid=${AUTH_MID}`, { method: 'POST', body: data });
		return res.json();
	}

	async function sendCode() {
		const email = emailInput.value.trim();
		if (!email) { showError('Введите email'); emailInput.focus(); return; }
		if (consent && !consent.checked) { showError('Подтвердите согласие на обработку персональных данных'); return; }

		setBusy(true);
		showError('');
		try {
			const json = await post('sendCode', { email, agree_pd: consent && consent.checked ? 1 : '' });
			if (json.success) {
				if (form.dataset.step !== 'code') toCodeStep();
				else if (resendBtn) {
					resendBtn.textContent = 'Код отправлен';
					resendBtn.disabled = true;
					setTimeout(() => { resendBtn.textContent = 'Отправить код ещё раз'; resendBtn.disabled = false; }, 30000);
				}
			} else {
				showError(json.error || 'Не удалось отправить код. Попробуйте ещё раз.');
			}
		} catch (e) {
			console.error('[auth] sendCode:', e);
			showError('Ошибка сети. Попробуйте ещё раз.');
		} finally {
			setBusy(false);
		}
	}

	async function login() {
		const email = emailInput.value.trim();
		const code = codeInput.value.trim();
		if (!code) { showError('Введите код из письма'); codeInput.focus(); return; }

		setBusy(true);
		showError('');
		try {
			const json = await post('login', { email, code });
			if (json.success) {
				if (window.popup) window.popup.close('auth');
				resetForm();
				document.dispatchEvent(new CustomEvent('auth:success', { detail: { email: json.email } }));
			} else {
				showError(json.error || 'Неверный код.');
			}
		} catch (e) {
			console.error('[auth] login:', e);
			showError('Ошибка сети. Попробуйте ещё раз.');
		} finally {
			setBusy(false);
		}
	}

	form.addEventListener('submit', (e) => {
		e.preventDefault();
		if (busy) return;
		form.dataset.step === 'code' ? login() : sendCode();
	});

	// Повторная отправка: сервер пришлёт ТОТ ЖЕ код (если он ещё действует), так что
	// задержавшееся первое письмо тоже останется рабочим.
	if (resendBtn) resendBtn.addEventListener('click', () => {
		if (!busy) sendCode();
	});
}
